import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { CustomHandler } from "@tKgpco/Store/CustomHandlerCreator";
import CustomInvoiceHistoryState from "@tKgpco/Store/Data/InvoiceHistoy/InvoiceHistoryStateExtension";

type HandlerType = CustomHandler<CustomInvoiceHistoryState>;

export const DispatchClearInvoiceHistoryFilter: HandlerType = props => {
    props.dispatch({
        type: "Custom/InvoiceHistory/ClearFilters",
        clearInvoiceHistoryFilters: props.parameter.clearInvoiceHistoryFilters,
        getInvoiceHistoryParams: props.parameter.getInvoiceHistoryParams,
    });
};

export const chain = [DispatchClearInvoiceHistoryFilter];

const customClearInvoiceHistoryFilter = createHandlerChainRunner(chain, "CustomClearInvoiceHistoryFilter");
export default customClearInvoiceHistoryFilter;
